import { View } from 'foundations-components/components/View';
import { NavMarker } from 'react-rhumb';
import { usePublicPageLoadTiming } from '../hooks/usePublicPageLoadTiming';
import { ERROR_SEVERITY, ErrorBoundary } from './error-boundary/ErrorBoundary';
import { PublicAppErrorFallback } from './error-boundary/PublicAppErrorFallback';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicPageWrapper = ({
  errorBoundaryName,
  navMarkerName,
  metricsRoute,
  chunkName,
  children
}) => {
  usePublicPageLoadTiming(metricsRoute, chunkName);
  return /*#__PURE__*/_jsxs(ErrorBoundary, {
    errorBoundaryName: errorBoundaryName,
    severity: ERROR_SEVERITY.HIGH,
    FallbackComponent: PublicAppErrorFallback,
    metricsOptions: {
      route: metricsRoute
    },
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName
    }), /*#__PURE__*/_jsx(View, {
      "data-selenium-id": "page-success",
      children: children
    })]
  });
};